module.exports = __webpack_public_path__ + "market/static/img/qctitle.16f78f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ques/qctitle.png
// module id = Qwc2
// module chunks = 1